export default __webpack_public_path__ + "static/media/companyimg2.61f143a6.jpeg";